import { findPaypalIdentity } from "../Util/queries";
import { constructPaypalIdentity } from "../Factory/factory";
import { PAYPAL_IDENTITY } from "../Reducers/paypalIdentityReducer";

export const getPaypalIdentity = () => async (dispatch) => {
    try {
        const response = await findPaypalIdentity();

        const paypalIdentity = constructPaypalIdentity(
            response.data.email,
            response.data.accountId,
            response.data.name,
            response.data.confirmedAt,
            response.data.verified
        );

        dispatch({
            type: PAYPAL_IDENTITY,
            payload: paypalIdentity,
        });
    } catch (e) {
        console.error(e);
        dispatch({
            type: PAYPAL_IDENTITY,
            payload: null,
        });
    }
};
